module.exports = __webpack_public_path__ + "e0106718/img/delete-icon.eb7de062.svg";